function ColumnLeft({
  entries,
}: {
  entries: [string, string | number | undefined][]
}) {
  return (
    <div className='tw-pb-4'>
      <div className='tw-bg-background tw-p-1 tw-rounded'>
        <div className='tw-flex tw-flex-col tw-gap-4 tw-p-4 tw-bg-white tw-rounded'>
          {entries.map(([key, value]) => (
            <div
              key={key}
              className='tw-flex tw-justify-between'
            >
              <span className='tw-flex-shrink-0 tw-text-text'>{key}</span>
              <strong className='tw-flex-grow tw-overflow-hidden tw-pl-6 tw-text-right tw-truncate tw-text-primary tw-font-medium'>
                {value}
              </strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ColumnLeft
